var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.703125 24H13.4531C13.8417 24 14.1562 23.6855 14.1562 23.2969V22.5469C14.1562 21.7702 13.5267 21.1406 12.75 21.1406V20.3002C12.75 19.1869 11.8444 18.2812 10.7311 18.2812H3.42516C2.31187 18.2812 1.40625 19.1869 1.40625 20.3002V21.1406C0.629531 21.1406 0 21.7702 0 22.5469V23.2969C0 23.685 0.315 24 0.703125 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79991 15.4847C9.26725 16.1048 10.149 16.2291 10.7691 15.7612C11.3893 15.2939 11.5135 14.4122 11.0462 13.7916L6.81475 8.17641C6.34741 7.55625 5.46569 7.43203 4.84553 7.89937C4.22538 8.36672 4.10116 9.24844 4.5685 9.86906L8.79991 15.4847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9075 7.86795C19.3748 8.4881 20.2565 8.61232 20.8772 8.14451C21.4973 7.67716 21.6215 6.79545 21.1537 6.17529L16.9223 0.560133C16.455 -0.0600228 15.5733 -0.184242 14.9531 0.283102C14.3329 0.750446 14.2087 1.63216 14.6765 2.25279L18.9075 7.86795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.823 11.9531C16.8622 11.1698 17.6427 10.1977 18.1307 9.17343L13.2069 2.63953C12.088 2.82656 10.9387 3.30843 9.89896 4.09171C8.85975 4.875 8.07928 5.84718 7.59131 6.87093L12.5151 13.4053C13.634 13.2183 14.7838 12.7364 15.823 11.9531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7221 12.1364C17.3949 12.4702 17.0499 12.7899 16.6698 13.0763C16.2896 13.3627 15.8869 13.6059 15.4763 13.8286L16.3932 15.0455L18.6394 13.3528L17.7221 12.1364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.485 14.476L17.2388 16.1686L21.4702 21.7842C21.9375 22.4044 22.8192 22.5286 23.4394 22.0613C24.0596 21.5939 24.1838 20.7122 23.7164 20.0916L19.485 14.476Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.c5d6d0d1.svg";
export { ForwardRef as ReactComponent };